import { MenuItem, styled } from "@mui/material";

export const MenuItemStyle = styled(MenuItem)(({ theme }) => ({
  color: theme.palette.common.white,
  "&.Mui-selected": {
    color: theme.palette.warning.main,
  },
}));
